export enum SearchTypeEnum {
  ID = 'id',
  CaseNumber = 'caseNumber',
}
